import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import ProductCard from "../components/ProductCard";

const CATS = ["All", "Hair Care", "Cycle Care", "Hormone Balance", "Kits"];

export default function Shop() {
    const [params, setParams] = useSearchParams();
    const initialCat = params.get("category") || "All";
    const initialQ = params.get("q") || "";
    const [category, setCategory] = useState(initialCat);
    const [q, setQ] = useState(initialQ);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sort, setSort] = useState("featured");

    useEffect(() => {
        setLoading(true);
        const p = {};
        if (category && category !== "All") p.category = category;
        if (q) p.q = q;
        api.get("/products", { params: p }).then((r) => setProducts(r.data || [])).finally(() => setLoading(false));
    }, [category, q]);

    useEffect(() => {
        const next = {};
        if (category && category !== "All") next.category = category;
        if (q) next.q = q;
        setParams(next, { replace: true });
    }, [category, q, setParams]);

    const sorted = [...products].sort((a, b) => {
        if (sort === "price-asc") return a.price - b.price;
        if (sort === "price-desc") return b.price - a.price;
        if (sort === "rating") return (b.rating || 0) - (a.rating || 0);
        return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
    });

    return (
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-10 sm:py-14" data-testid="shop-page">
            <div className="text-center mb-10 sm:mb-14">
                <p className="eyebrow">Daily balance for modern life</p>
                <h1 className="h-display text-[36px] sm:text-[56px] md:text-[64px] mt-3 sm:mt-4">The Apothecary</h1>
                <p className="text-[var(--body)] max-w-xl mx-auto mt-3 sm:mt-4 text-[14px] sm:text-[16px]">
                    Discover our complete library of clinically-reviewed, evidence-based formulations.
                </p>
            </div>

            <div className="flex flex-col md:flex-row flex-wrap md:items-center md:justify-between gap-4 mb-8 sm:mb-10">
                <div className="flex flex-wrap gap-2 -mx-1 px-1 overflow-x-auto" data-testid="category-filter">
                    {CATS.map((c) => (
                        <button
                            key={c}
                            onClick={() => setCategory(c)}
                            className={`btn btn-sm whitespace-nowrap ${category === c ? "btn-primary" : "btn-outline"}`}
                            data-testid={`shop-cat-${c.replace(/ /g, "-").toLowerCase()}`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
                <div className="flex items-center gap-2">
                    <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="field flex-1 max-w-[200px]" data-testid="shop-search" />
                    <select value={sort} onChange={(e) => setSort(e.target.value)} className="field max-w-[180px]" data-testid="shop-sort">
                        <option value="featured">Featured</option>
                        <option value="price-asc">Price: Low to High</option>
                        <option value="price-desc">Price: High to Low</option>
                        <option value="rating">Top Rated</option>
                    </select>
                </div>
            </div>

            <div className="card p-5 sm:p-8 lg:p-12">
                {loading ? (
                    <div className="py-20 text-center text-[var(--body)]">Loading…</div>
                ) : sorted.length === 0 ? (
                    <div className="py-20 text-center">
                        <div className="text-5xl mb-3">🌸</div>
                        <h3 className="font-serif text-[22px] sm:text-[24px] text-[var(--ink)] mb-2">No products found</h3>
                        <p className="text-[var(--body)]">Try a different category or search term.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-4 sm:gap-x-8 gap-y-10 sm:gap-y-14" data-testid="shop-grid">
                        {sorted.map((p) => <ProductCard key={p.id} product={p} />)}
                    </div>
                )}
            </div>
        </div>
    );
}
